import React from 'react';
import { useNavigate } from "react-router-dom";
import FadeInFromLeft from './FadeInFromLeft';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import './Welcome.css';
import StudentsWalking from '../../images/Students_Walking.png';
import PathToSudentSuccess from '../../images/Path_to_Graduate_Success.png';
const placeholderImg = "https://images.unsplash.com/photo-1464983953574-0892a716854b?fit=crop&w=700&q=80";

export default function HeroSection({ isMobile }) {
  const navigate = useNavigate();
  const { isLoggedIn, userRole } = useContext(AuthContext);

  const handleButtonClick = () => {
    if (!isLoggedIn) {
      navigate("/HomePage");
    } else if (userRole === 'student') {
      navigate("/student-dashboard");
    } else if (userRole === 'professor') {
      navigate("/professor-dashboard");
    } else if (userRole === 'admin') {
      navigate("/admin");
    }
  };

  return (
    <main className={`hero-section ${isMobile ? 'mobile' : ''}`}>
      {/* LEFT COLUMN WRAPPER */}
      <div className={`left-cards-wrapper ${isMobile ? 'mobile' : ''}`}>
        {/* FIRST LEFT BOX: Slogan + Description */}
        <div className={`hero-card-stacked ${isMobile ? 'mobile' : ''}`}>
          <FadeInFromLeft>
            <div>
              <h2 className={`hero-title ${isMobile ? 'mobile' : ''}`}>
                Students advance.<br />Faculty inspire.
              </h2>
              <div className={`hero-description ${isMobile ? 'mobile' : ''}`}>
                NeuHawk saves time by pairing students with the right PhD opportunities while helping professors easily find and connect with top candidates.
              </div>
              <div style={{ display: "flex", gap: "1.15rem", marginTop: "0.2rem", marginBottom: "1rem", flexWrap: "wrap" }}>
                <button
                  className={`cta-button ${isMobile ? 'mobile' : ''}`}
                  onClick={() => handleButtonClick()}
                  aria-label="Get matched with faculty in 2 minutes"
                >
                  Get matched in 2 minutes
                </button>
                {/* <button
                  className={`cta-button secondary ${isMobile ? 'mobile' : ''}`}
                  onClick={() => navigate('/pricing')}
                  aria-label="View pricing plans"
                  style={{
                    background: 'transparent',
                    border: '2px solid #3C6E71',
                    color: '#3C6E71'
                  }}
                >
                  View Pricing
                </button> */}
              </div>
            </div>
          </FadeInFromLeft>
        </div>

        {/* SECOND LEFT BOX: PhD Made Easy */}
        <div className={`hero-card-stacked ${isMobile ? 'mobile' : ''}`}>
          <FadeInFromLeft delay={isMobile ? 150 : 350}>
            <div>
              <h2 className={`hero-title ${isMobile ? 'mobile' : ''}`}>
                PhD Made Easy
              </h2>
              <div className={`hero-description ${isMobile ? 'mobile' : ''}`}>
                Navigate your doctoral journey with confidence. Our platform streamlines the complex process of finding the perfect PhD program, turning what used to take months of searching into a simple, guided experience that connects you with opportunities tailored to your academic goals and research interests.
              </div>
            </div>
          </FadeInFromLeft>
        </div>
      </div>

      {/* RIGHT BOX: Mission & Vision */}
      <FadeInFromLeft delay={isMobile ? 100 : 250}>
        <div className={`mission-card ${isMobile ? 'mobile' : ''}`}>
          <div style={{ width: "100%", marginBottom: "1.2rem" }}>
            <img
              src={PathToSudentSuccess}
              alt="Students and faculty collaborating in outdoor academic setting"
              className={`mission-image ${isMobile ? 'mobile' : ''}`}
            />
          </div>
          {/* For Students Section */}
          <h3 className={`mission-title ${isMobile ? 'mobile' : ''}`}>
            For Students
          </h3>
          <div className={`feature-blocks ${isMobile ? 'mobile' : ''}`}>
            <div className="feature-block">
              <div className="feature-icon student-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.5 14H20.5L22 15.5V20.5L20.5 22H15.5L14 20.5V15.5L15.5 14Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" fill="none"/>
                  <path d="M3 21V19C3 17.8954 3.89543 17 5 17H13C14.1046 17 15 17.8954 15 19V21" stroke="currentColor" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <h4 className="feature-title">Discover</h4>
            </div>
            <div className="feature-block">
              <div className="feature-icon student-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature-title">Match</h4>
            </div>
            <div className="feature-block">
              <div className="feature-icon student-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature-title">Apply</h4>
            </div>
          </div>
          {/* For Faculty Section */}
          <h3 className={`vision-title ${isMobile ? 'mobile' : ''}`}>
            For Faculty
          </h3>
          <div className={`feature-blocks ${isMobile ? 'mobile' : ''}`}>
            <div className="feature-block">
              <div className="feature-icon faculty-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L3 7L12 12L21 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 17L12 22L21 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 12L12 17L21 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature-title">Post</h4>
            </div>
            <div className="feature-block">
              <div className="feature-icon faculty-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 20H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16.5 3.5C16.8978 3.10218 17.4374 2.87868 18 2.87868C18.2786 2.87868 18.5544 2.93355 18.8118 3.04009C19.0692 3.14662 19.303 3.30301 19.5 3.5C19.697 3.69699 19.8534 3.9308 19.9599 4.18819C20.0665 4.44558 20.1213 4.72142 20.1213 5C20.1213 5.27858 20.0665 5.55442 19.9599 5.81181C19.8534 6.0692 19.697 6.30301 19.5 6.5L7 19L3 20L4 16L16.5 3.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature-title">Manage</h4>
            </div>
            <div className="feature-block">
              <div className="feature-icon faculty-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 21V19C16 17.8954 15.1046 17 14 17H10C8.89543 17 8 17.8954 8 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20 8V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M23 11H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M4 8V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 11H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h4 className="feature-title">Fill</h4>
            </div>
          </div>
        </div>
      </FadeInFromLeft>
    </main>
  );
}